export var source_release_note_category_tag = { "uid": "source_release_note_category_tag", "fields": { "title": { "defaultValue": "" }, "tag_title": { "defaultValue": "" } } };
